import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { hasSubmitSucceeded, isSubmitting } from 'redux-form'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'

import { Input, InputPassword } from 'components/fields'
import { Form } from 'components/layout'
import { FormButton, Button, Module } from 'components/misc'
import { LoaderOverlay } from 'components/loaders'
import { form } from 'helpers/decorators'
import { apiConfiguration, apiPasswords } from 'helpers/decorators/api'
import validate from './password-reset-form.validation'
import config from 'config'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'
import { get } from 'lodash'

const formName = 'forgottenPasswordForm'

@form({
  form: formName,
  disableHook: true,
  validate
})
@apiConfiguration()
@apiPasswords()
@connect(
  state => ({
    isSubmitted: hasSubmitSucceeded(formName)(state),
    isSubmitting: isSubmitting(formName)(state)
  }),
  { push }
)
class PasswordResetForm extends Component {
  static propTypes = {
    pristine: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onResetPassword: PropTypes.func.isRequired,
    location: PropTypes.object,
    isSubmitting: PropTypes.bool,
    push: PropTypes.func,
    onGetConfigurationValue: PropTypes.func.isRequired
  }

  static defaultProps = {
    loading: false
  }

  componentDidMount = async ()=> {
   await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.passwordSpecChars.id, null, true)
  }

  redirectToLogin = () => this.props.push(`${config.publicPath}/`)

  handleSubmit = fields =>
    this.props
      .onResetPassword(fields)
      .then(() => this.props.push(`${config.publicPath}/password-reset/success`))

  render() {
    const { handleSubmit, pristine, isSubmitting, location } = this.props

    const isSubmitted = location && location.pathname.includes('/success')

    const passwordSpecChars = get(this.props, `configuration.values.${CONFIGURATION_KEYS.passwordSpecChars.id}.textValue`)

    return (
      <Module>
        <LoaderOverlay isLoading={isSubmitting}>
          <Form onSubmit={handleSubmit(this.handleSubmit)}>
            <h2 className="alpha nowrap">
              <FormattedMessage
                id="moduleTitle.reset_password"
                defaultMessage="Reset Password"
              />
            </h2>

            {isSubmitted && (
              <div>
                <p className="delta text--center">
                  <FormattedMessage
                    id="notifications.your_new_password_has_been_set"
                    defaultMessage="Your new password has been set"
                  />
                </p>
                <Button
                  type="button"
                  onClick={this.redirectToLogin}
                  simple
                  fluid
                >
                  <FormattedMessage
                    id="moduleTitle.login"
                    defaultMessage="Log in"
                  />
                </Button>
              </div>
            )}

            {!isSubmitted && [
              <InputPassword
                name="password"
                type="password"
                label="Password"
                intlKey="label.password"
                passwordSpecChars={passwordSpecChars}
              />,
              <Input
                name="passwordVerify"
                type="password"
                label="Password again"
                intlKey="label.password_again"
              />,
              <FormButton
                pristine={pristine}
                simple
                fluid
                isLoading={isSubmitting}
              >
                <FormattedMessage id="button.send" defaultMessage="Send" />
              </FormButton>
            ]}
          </Form>
        </LoaderOverlay>
      </Module>
    )
  }
}

export default PasswordResetForm
